export enum FinalStatus {
  Satisfied = 1,
  NoResponse = 2,
  UnderConnection = 3,
  UnSatisfied = 4
}
